<app-stages [stages]="stages" currentStage="Przedmiot deklaracji"></app-stages>
<br>
@if (!pending() && !loading()) {
  <form novalidate autocomplete="off" [formGroup]="form" (ngSubmit)="submitAndGoNext()">
    <fieldset>
      <legend>
        Informacje podstawowe
      </legend>
      <app-alert [closable]="false">
        Częściowe zwolnienie z opłaty za gospodarowanie odpadami komunalnymi obowiązuje wyłącznie od miesiąca złożenia
        deklaracji. Nie ma możliwości naliczenia "ulgi" z datą wsteczną.
      </app-alert>
      <div class="row">
        <div class="col-md-5">
          <div class='form-group' *ngIf='"submissionPurpose" as controlName'>
            <label [for]='controlName'>
              Okoliczności powodujące obowiązek złożenia deklaracji *
            </label>
            <select
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'>
              <option value=''>Wybierz</option>
              @for (item of form.submissionPurposeOptions; track $index) {
                <option [value]='item'>{{ item }}</option>
              }
            </select>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"startDate" as controlName'>
            <label [for]='controlName'>
              Data od *
            </label>
            <app-date-picker
              mode="month"
              [id]='controlName'
              [formControlName]='controlName'>
            </app-date-picker>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class="col-md-5">
          <div class='form-group' *ngIf='"entityKind" as controlName'>
            <label [for]='controlName'>
              Rodzaj podmiotu *
            </label>
            <select
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'>
              <option value=''>Wybierz</option>
              @for (item of form.entityKindOptions; track $index) {
                <option [value]='item'>{{ item }}</option>
              }
            </select>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class="col-12">
          <p id="propertyTypeDesc" class="pb-3">
            Deklaracja dotyczy *:
          </p>
          <div class="form-group" *ngIf='"propertyType" as controlName'>
            @for (item of form.propertyTypeOptions; track $index) {
              <div class="custom-radio custom-inline" [ngClass]='{ "is-invalid": form.showError(controlName) }'>
                <input aria-labelledby="propertyTypeDesc"
                       [name]="controlName"
                       [formControlName]='controlName'
                       type="radio"
                       [id]="controlName + $index"
                       [value]="item">
                <label [for]="controlName + $index">
                  {{ item }}
                </label>
              </div>
            }
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
    </fieldset>
    <fieldset>
      <legend>
        Adres nieruchomości, na której powstają odpady komunalne
      </legend>
      <div class="row">
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"registrationNumber" as controlName'>
            <label [for]='controlName'>
              Numer działki
            </label>
            <input
              [id]='controlName'
              [formControlName]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              placeholder='Wpisz tu nr. działki'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"city" as controlName'>
            <label [for]='controlName'>
              Miejscowość *
            </label>
            <input
              [id]='controlName'
              [formControlName]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              placeholder='Wpisz tu miejscowość'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"street" as controlName'>
            <label [for]='controlName'>
              Ulica
            </label>
            <input
              [id]='controlName'
              [formControlName]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              placeholder='Wpisz tu nazwę ulicy'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-2'>
          <div class='form-group' *ngIf='"houseNumber" as controlName'>
            <label [for]='controlName'>
              Nr domu *
            </label>
            <input
              [id]='controlName'
              [formControlName]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              placeholder='Wpisz tu nr domu'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-2'>
          <div class='form-group' *ngIf='"apartmentNumber" as controlName'>
            <label [for]='controlName'>
              Nr mieszkania
            </label>
            <input
              [id]='controlName'
              [formControlName]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              placeholder='Wpisz tu nr mieszkania'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"identicalBuildingsCount" as controlName'>
            <label [for]='controlName'>
              Liczba lokali mieszkalnych
            </label>
            <input
              mask='0*'
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu liczbę'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
    </fieldset>
    <fieldset>
      <legend>
        Podstawa wyliczenia opłaty
      </legend>
      <div class="row">
        <div class='col-md-3'>
          <div class='form-group' *ngIf='"numberOfResidents" as controlName'>
            <label [for]='controlName'>
              Liczba osób zamieszkujących *
            </label>
            <input
              (change)="form.calcFeeAmount(); form.numberOfResidentsChange(form.getElement($event).value)"
              mask='0*'
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu liczbę'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class="col-md-3">
          <div class='form-group' *ngIf='"feeRate" as controlName'>
            <label [for]='controlName'>
              Stawka (zł)*
            </label>
            <input
              (change)="form.calcFeeAmount()"
              mask='separator.2'
              decimalMarker=","
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu stawkę'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class="col-md-3">
          <div class='form-group' *ngIf='"feeAmount" as controlName'>
            <label [for]='controlName'>
              Kwota opłaty (zł)*
            </label>
            <input
              readonly
              mask='separator.2'
              decimalMarker=","
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
    </fieldset>
    <fieldset>
      <legend>
        Oświadczenie o kompostowaniu bioodpadów
      </legend>
      <div class="row">
        <div class="col-12">
          <p id="propertyHasComposterDesc" class="pb-3">
            Oświadczam, że na nieruchomości wskazanej powyżej <strong>posiadam kompostownik przydomowy</strong> i
            kompostuję w nim
            bioodpady w związku z tym chcę skorzystać z częściowego zwolnienia w opłacie *:
          </p>
          <div class='form-group' *ngIf='"propertyHasComposter" as controlName'>
            <div class="custom-radio custom-inline" [ngClass]='{ "is-invalid": form.showError(controlName) }'>
              <input
                (change)="form.propertyHasComposterChange(true)"
                aria-describedby="propertyHasComposterDesc"
                [formControlName]="controlName"
                type="radio"
                id="propertyHasComposterYes"
                [value]="true">
              <label for="propertyHasComposterYes">Tak</label>
            </div>
            <div class="custom-radio custom-inline" [ngClass]='{ "is-invalid": form.showError(controlName) }'>
              <input
                (change)="form.propertyHasComposterChange(false)"
                aria-describedby="propertyHasComposterDesc"
                [formControlName]="controlName"
                type="radio"
                id="propertyHasComposterNo"
                [value]="false">
              <label for="propertyHasComposterNo">Nie</label>
            </div>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        @if (form.numberOfResidentsForBioExemption) {
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"numberOfResidentsForBioExemption" as controlName'>
              <label [for]='controlName'>
                Liczba osób uprawniona do zwolnienia *
              </label>
              <input
                (change)="form.calcBioExemptionAmount()"
                mask='0*'
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu liczbę'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        }
        @if (form.bioExemptionRate) {
          <div class='col-md-4'>
            <div class='form-group' *ngIf='"bioExemptionRate" as controlName'>
              <label [for]='controlName'>
                Stawka zwolnienia (zł)*
              </label>
              <input
                (change)="form.calcBioExemptionAmount()"
                mask='separator.2'
                decimalMarker=","
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                placeholder='Wpisz tu stawkę'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        }
        @if (form.bioExemptionAmount) {
          <div class="col-md-4">
            <div class='form-group' *ngIf='"bioExemptionAmount" as controlName'>
              <label [for]='controlName'>
                Kwota zwolnienia (zł)*
              </label>
              <input
                mask='separator.2'
                decimalMarker=","
                readonly
                [id]='controlName'
                [ngClass]='{ "is-invalid": form.showError(controlName) }'
                [formControlName]='controlName'
                type='text'>
              <app-validation-errors [control]='form.get(controlName)'>
              </app-validation-errors>
            </div>
          </div>
        }
      </div>
    </fieldset>
    <app-alert [closable]="false">
      Korzystającym z częściowego zwolnienia gmina nie zapewnia odbioru bioodpadów stanowiących odpady komunalne z
      terenu nieruchomości wskazanej powyżej, której dotyczy deklaracja
    </app-alert>
    <fieldset>
      <legend>
        Zwolnienie z tytułu rodziny wielodzietnej w rozumieniu ustawy o Karcie Dużej Rodziny lub z tytułu kryterium
        dochodowego
      </legend>
      <div class="row">
        <div class="col-md-3">
          <div class='form-group' *ngIf='"partialTypeExemption" as controlName'>
            <label [for]='controlName'>
              Rodzaj <br> częściowego zwolnienia *
            </label>
            <select
              (change)="form.partialTypeExemptionChange(form.getElement($event).value)"
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'>
              <option value=''>Wybierz</option>
              @for (item of form.partialTypeExemptions; track $index) {
                <option [value]='item'>{{ item }}</option>
              }
            </select>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-3'>
          <div class='form-group' *ngIf='"numberOfResidentsForExemption" as controlName'>
            <label [for]='controlName'>
              Liczba osób uprawniona <br> do
              zwolnienia @if (form.get(controlName)?.hasValidator(form.validators.required)) {
              *
            }
            </label>
            <input
              (change)="form.calcExemptionAmount()"
              mask='0*'
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu liczbę'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-3'>
          <div class='form-group' *ngIf='"exemptionAmountRate" as controlName'>
            <label [for]='controlName'>
              Kwota częściowego <br> zwolnienia z opłaty (zł)
              @if (form.get(controlName)?.hasValidator(form.validators.required)) {
                *
              }
            </label>
            <input
              (change)="form.calcExemptionAmount()"
              mask='separator.2'
              [dropSpecialCharacters]="false"
              decimalMarker=","
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu kwotę [zł]'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-3'>
          <div class='form-group' *ngIf='"exemptionAmount" as controlName'>
            <label [for]='controlName'>
              Wysokość częściowego <br> zwolnienia z opłaty
              (zł) @if (form.get(controlName)?.hasValidator(form.validators.required)) {
              *
            }
            </label>
            <input
              readonly
              mask='separator.2'
              [dropSpecialCharacters]="false"
              decimalMarker=","
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
    </fieldset>
    <br>
    <app-alert
      alertTitle="Wysokość miesiecznej opłaty po uwzględnieniu zwolnień:"
      [closable]="false">
      {{ form.totalMonthlyFeeAmount.value | currency }}
    </app-alert>
    @if (form.largeFamilyForm; as largeFamilyForm) {
      <app-large-family-form [form]="largeFamilyForm">
      </app-large-family-form>
    }
    <div class='application-actions'>
      <button
        (click)="onCancel()"
        type='button'
        class='btn btn-secondary'>
        <span>
          Wstecz
        </span>
      </button>
      <button
        type='submit'
        class='btn btn-primary'>
        <span>Zapisz i przejdź dalej</span>
      </button>
    </div>
  </form>
} @else {
  <app-spinner>
    {{ pending() ? 'Poczekaj trwa zapisywania danych...' : 'Poczekaj trwa ładowanie danych...' }}
  </app-spinner>
}
